module.exports = __webpack_public_path__ + "favicon.983e64a2.ico";


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/images/favicon.ico
// module id = 1326
// module chunks = 1